import React, { useState, useContext, useEffect, useRef, useCallback } from 'react';
import { get, ApiError } from 'aws-amplify/api';

const MaintenanceContext = React.createContext();

export const useMaintenanceContext = () => useContext(MaintenanceContext);

const POLL_INTERVAL_MS = 30000;

export const MaintenanceContextProvider = ({ children }) => {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const pollRef = useRef(null);

  const checkRecovery = useCallback(async () => {
    try {
      await get({ apiName: 'Scanseqr', path: 'entities/get-users-entities' }).response;
      window.location.reload();
    } catch (error) {
      if (!(error instanceof ApiError) || !error.response) return; // CORS / network — keep polling
      const { statusCode, headers } = error.response;
      if (statusCode === 403 && headers?.['x-maintenance-mode'] === 'true') return; // still in maintenance
      window.location.reload(); // any other API response = maintenance over
    }
  }, []);

  useEffect(() => {
    const handleMaintenance = () => setIsMaintenance(true);
    window.addEventListener('maintenance-mode', handleMaintenance);
    return () => window.removeEventListener('maintenance-mode', handleMaintenance);
  }, []);

  useEffect(() => {
    if (!isMaintenance) return;

    // Primary: react immediately when any api.js call succeeds
    const handleRecovery = () => window.location.reload();
    window.addEventListener('maintenance-recovery', handleRecovery);

    // Backup: poll every 30s in case the app is idle
    pollRef.current = setInterval(checkRecovery, POLL_INTERVAL_MS);

    return () => {
      window.removeEventListener('maintenance-recovery', handleRecovery);
      clearInterval(pollRef.current);
    };
  }, [isMaintenance, checkRecovery]);

  return (
    <MaintenanceContext.Provider value={{ isMaintenance }}>
      {children}
    </MaintenanceContext.Provider>
  );
};
